"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.walkAST = void 0;
const types_1 = require("./types");
/**
 * Default method to walk an AST an invoke the corresponding listener methods for each node.
 *
 * @param listener Listener to invoke enter and exit methods
 * @param jast JQL AST to walk
 */
exports.walkAST = (listener, jast) => {
    jast.query && enterQuery(listener, jast.query);
};
const enterQuery = (listener, query) => {
    listener.enterQuery && listener.enterQuery(query);
    query.where && enterClause(listener, query.where);
    query.orderBy && enterOrderBy(listener, query.orderBy);
    listener.exitQuery && listener.exitQuery(query);
};
const enterClause = (listener, clause) => {
    listener.enterClause && listener.enterClause(clause);
    switch (clause.clauseType) {
        case types_1.CLAUSE_TYPE_COMPOUND:
            enterCompoundClause(listener, clause);
            break;
        case types_1.CLAUSE_TYPE_FIELD_VALUE:
            enterFieldValueClause(listener, clause);
            break;
        case types_1.CLAUSE_TYPE_FIELD_CHANGED:
            enterFieldChangedClause(listener, clause);
            break;
        case types_1.CLAUSE_TYPE_FIELD_WAS:
            enterFieldWasClause(listener, clause);
            break;
    }
    listener.exitClause && listener.exitClause(clause);
};
const enterCompoundClause = (listener, compoundClause) => {
    listener.enterCompoundClause && listener.enterCompoundClause(compoundClause);
    enterCompoundOperator(listener, compoundClause.operator);
    compoundClause.clauses.forEach(clause => enterClause(listener, clause));
    listener.exitCompoundClause && listener.exitCompoundClause(compoundClause);
};
const enterFieldValueClause = (listener, fieldValueClause) => {
    listener.enterFieldValueClause &&
        listener.enterFieldValueClause(fieldValueClause);
    enterField(listener, fieldValueClause.field);
    fieldValueClause.operator &&
        enterFieldValueOperator(listener, fieldValueClause.operator);
    fieldValueClause.operand &&
        enterFieldOperand(listener, fieldValueClause.operand);
    listener.exitFieldValueClause &&
        listener.exitFieldValueClause(fieldValueClause);
};
const enterFieldChangedClause = (listener, fieldChangedClause) => {
    listener.enterFieldChangedClause &&
        listener.enterFieldChangedClause(fieldChangedClause);
    enterField(listener, fieldChangedClause.field);
    fieldChangedClause.operator &&
        enterFieldChangedOperator(listener, fieldChangedClause.operator);
    fieldChangedClause.predicates.forEach(predicate => enterFieldChangedTimePredicate(listener, predicate));
    listener.exitFieldChangedClause &&
        listener.exitFieldChangedClause(fieldChangedClause);
};
const enterFieldWasClause = (listener, fieldWasClause) => {
    listener.enterFieldWasClause && listener.enterFieldWasClause(fieldWasClause);
    enterField(listener, fieldWasClause.field);
    fieldWasClause.operator &&
        enterFieldWasOperator(listener, fieldWasClause.operator);
    fieldWasClause.operand && enterFieldOperand(listener, fieldWasClause.operand);
    fieldWasClause.predicates.forEach(predicate => enterFieldChangedTimePredicate(listener, predicate));
    listener.exitFieldWasClause && listener.exitFieldWasClause(fieldWasClause);
};
const enterCompoundOperator = (listener, compoundOperator) => {
    listener.enterCompoundOperator &&
        listener.enterCompoundOperator(compoundOperator);
    listener.exitCompoundOperator &&
        listener.exitCompoundOperator(compoundOperator);
};
const enterField = (listener, field) => {
    listener.enterField && listener.enterField(field);
    listener.exitField && listener.exitField(field);
};
const enterFieldValueOperator = (listener, fieldValueOperator) => {
    listener.enterFieldValueOperator &&
        listener.enterFieldValueOperator(fieldValueOperator);
    listener.exitFieldValueOperator &&
        listener.exitFieldValueOperator(fieldValueOperator);
};
const enterFieldWasOperator = (listener, fieldWasOperator) => {
    listener.enterFieldWasOperator &&
        listener.enterFieldWasOperator(fieldWasOperator);
    listener.exitFieldWasOperator &&
        listener.exitFieldWasOperator(fieldWasOperator);
};
const enterFieldChangedOperator = (listener, fieldChangedOperator) => {
    listener.enterFieldChangedOperator &&
        listener.enterFieldChangedOperator(fieldChangedOperator);
    listener.exitFieldChangedOperator &&
        listener.exitFieldChangedOperator(fieldChangedOperator);
};
const enterFieldOperand = (listener, fieldOperand) => {
    listener.enterFieldOperand && listener.enterFieldOperand(fieldOperand);
    switch (fieldOperand.operandType) {
        case types_1.OPERAND_TYPE_LIST:
            enterListOperand(listener, fieldOperand);
            break;
        case types_1.OPERAND_TYPE_FIELD_VALUE:
            enterFieldValueOperand(listener, fieldOperand);
            break;
        case types_1.OPERAND_TYPE_KEYWORD:
            enterKeywordOperand(listener, fieldOperand);
            break;
        case types_1.OPERAND_TYPE_FUNCTION:
            enterFunctionOperand(listener, fieldOperand);
            break;
    }
    listener.exitFieldOperand && listener.exitFieldOperand(fieldOperand);
};
const enterListOperand = (listener, listOperand) => {
    listener.enterListOperand && listener.enterListOperand(listOperand);
    listOperand.values.forEach(operand => {
        switch (operand.operandType) {
            case types_1.OPERAND_TYPE_FIELD_VALUE:
                enterFieldValueOperand(listener, operand);
                break;
            case types_1.OPERAND_TYPE_KEYWORD:
                enterKeywordOperand(listener, operand);
                break;
            case types_1.OPERAND_TYPE_FUNCTION:
                enterFunctionOperand(listener, operand);
                break;
        }
    });
    listener.exitListOperand && listener.exitListOperand(listOperand);
};
const enterFieldValueOperand = (listener, fieldValueOperand) => {
    listener.enterFieldValueOperand &&
        listener.enterFieldValueOperand(fieldValueOperand);
    listener.exitFieldValueOperand &&
        listener.exitFieldValueOperand(fieldValueOperand);
};
const enterKeywordOperand = (listener, keywordOperand) => {
    listener.enterKeywordOperand && listener.enterKeywordOperand(keywordOperand);
    listener.exitKeywordOperand && listener.exitKeywordOperand(keywordOperand);
};
const enterFunctionOperand = (listener, functionOperand) => {
    listener.enterFunctionOperand &&
        listener.enterFunctionOperand(functionOperand);
    enterFunction(listener, functionOperand.function);
    functionOperand.arguments.forEach(arg => enterArgument(listener, arg));
    listener.exitFunctionOperand && listener.exitFunctionOperand(functionOperand);
};
const enterFunction = (listener, functionString) => {
    listener.enterFunction && listener.enterFunction(functionString);
    listener.exitFunction && listener.exitFunction(functionString);
};
const enterArgument = (listener, argument) => {
    listener.enterArgument && listener.enterArgument(argument);
    listener.exitArgument && listener.exitArgument(argument);
};
const enterFieldChangedTimePredicate = (listener, fieldChangedTimePredicate) => {
    listener.enterFieldChangedTimePredicate &&
        listener.enterFieldChangedTimePredicate(fieldChangedTimePredicate);
    enterFieldChangedTimePredicateOperator(listener, fieldChangedTimePredicate.operator);
    fieldChangedTimePredicate.operand &&
        enterFieldOperand(listener, fieldChangedTimePredicate.operand);
    listener.exitFieldChangedTimePredicate &&
        listener.exitFieldChangedTimePredicate(fieldChangedTimePredicate);
};
const enterFieldChangedTimePredicateOperator = (listener, fieldChangedTimePredicateOperator) => {
    listener.enterFieldChangedTimePredicateOperator &&
        listener.enterFieldChangedTimePredicateOperator(fieldChangedTimePredicateOperator);
    listener.exitFieldChangedTimePredicateOperator &&
        listener.exitFieldChangedTimePredicateOperator(fieldChangedTimePredicateOperator);
};
const enterOrderBy = (listener, orderBy) => {
    listener.enterOrderBy && listener.enterOrderBy(orderBy);
    enterOrderByOperator(listener, orderBy.operator);
    orderBy.fields.forEach(field => enterOrderByField(listener, field));
    listener.exitOrderBy && listener.exitOrderBy(orderBy);
};
const enterOrderByOperator = (listener, orderByOperator) => {
    listener.enterOrderByOperator &&
        listener.enterOrderByOperator(orderByOperator);
    listener.exitOrderByOperator && listener.exitOrderByOperator(orderByOperator);
};
const enterOrderByField = (listener, orderByField) => {
    listener.enterOrderByField && listener.enterOrderByField(orderByField);
    enterField(listener, orderByField.field);
    orderByField.direction &&
        enterOrderByDirection(listener, orderByField.direction);
    listener.exitOrderByField && listener.exitOrderByField(orderByField);
};
const enterOrderByDirection = (listener, orderByDirection) => {
    listener.enterOrderByDirection &&
        listener.enterOrderByDirection(orderByDirection);
    listener.exitOrderByDirection &&
        listener.exitOrderByDirection(orderByDirection);
};
//# sourceMappingURL=JastWalker.js.map